import {
    localStorageGetItem,
    localStorageRemoveItem,
    localStorageSetItem,
} from '../components/storage/localStorageManager';

export const tokenManager = {
    getToken: function () {
        const token = localStorageGetItem('token');
        return token || null;
    },

    setToken: function (token: string) {
        localStorageSetItem('token', token);
    },

    removeToken: function () {
        if (this.getToken()) {
            localStorageRemoveItem('token');
        }
    },

    getScreenXToken: function () {
        const token = localStorageGetItem('screenX_Token');
        return token || null;
    },

    setScreenXToken: function (token: string) {
        localStorageSetItem('screenX_Token', token);
    },

    removeScreenXToken: function () {
        if (this.getToken()) {
            localStorageRemoveItem('screenX_Token');
        }
    },
};
